import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Indicadores from "./containers/Indicadores/Indicadores";
import Painel from "./containers/Painel/Painel";
import Login from "./containers/Auth/Login";
import Logout from "./containers/Auth/Logout";
import Usuarios from "./containers/Cadastros/Usuarios/Usuarios";
import Fabricantes from "./containers/Cadastros/Fabricantes/Fabricantes";
import Caracteristicas from "./containers/Cadastros/Caracteristicas/Caracteristicas";
import Setor from "./containers/Cadastros/Setor/Setor";
import Grupo from "./containers/Cadastros/Grupo/Grupo";
import Lojas from "./containers/Cadastros/Lojas/Lojas";
import AnaliseRepo from "./containers/AnaliseRepo/AnaliseRepo";
import PowerBi from "./containers/PowerBi/Index";
import { PowerBiGestaoCat, PowerBiPricing } from "./containers/PowerBi/Lojas";
import FabricantesIndefinidos from "./containers/Outros/FabricantesIndefinidos";
import { connect } from "react-redux";
import { logIn, logOut, setDados, fetch } from "./actions";
import ErrorBoundary from "./components/ErrorBoundary";
import ErrorScreen from './components/ErrorScreen';
import { LoadingScreenMain } from "./components/Diversos";

export function Main(props) {
  const [loading, setLoading] = useState(true);
  const [erroIni, setErroIni] = useState(null);

  useEffect(() => {
    if (!props.auth.tokenId, props.tokenId) {

      if (props.tokenId == 'token') {
        props.logOut();
        setLoading(false);
      }
      else {
        props.logIn({ user: props.user, tokenId: props.tokenId, refreshToken: props.refreshToken });
      }
    }
    else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (props.auth.tokenId) {
      setLoading(true);

      props.fetch().get('/outros')
        .then(function (response) {
          setLoading(false);
          if (response && response.data.sucesso) {
            props.setDados(response.data);
          }
          else {
            props.logOut();
          }
        })
        .catch(function (error) {
          props.logOut();
          setLoading(false);
          setErroIni(error);
        });
    }
  }, [props.auth.tokenId, props.auth.reload]);

  if (erroIni) {
    return <ErrorScreen />
  }


  if (loading) {
    return <LoadingScreenMain />
  }

  if (props.auth.user && !props.dados.tipo) {
    return <LoadingScreenMain />
  }

  return (
    <ErrorBoundary>
      {(!props.auth.user) ? (
        <Router>
          <Switch>
            <Route path="/login" component={Login} />
            <Redirect path="*" to="/login" />

          </Switch>
        </Router>
      ) : (
        <Router>
          {/* <Switch>
            <Route path="/login" component={Login} />
            <Route path="/sair" component={Logout} /> */}

          {(!props.dados.tipo) && <>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/sair" component={Logout} />
              <Redirect path="*" to="/sair" />
            </Switch>
          </>}

          {(props.dados.tipo === 'loja') && <>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/sair" component={Logout} />
              <Route path="/powerbi/gc" component={PowerBiGestaoCat} />
              <Route path="/powerbi/prc" component={PowerBiPricing} />
              <Redirect path="*" to="/powerbi/gc" />
            </Switch>
          </>}

          {props.dados.tipo === 'adm' && <>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/sair" component={Logout} />
              <Route exact path="/inicio" component={Usuarios} />
              <Route path="/ranking" component={Painel} />
              <Route path="/cad/usu" component={Usuarios} />
              <Route path="/cad/fab" component={Fabricantes} />
              <Route path="/cad/carac/:name" component={Caracteristicas} />
              <Route path="/cad/set" component={Setor} />
              <Route path="/cad/gru" component={Grupo} />
              <Route path="/cad/em" component={Lojas} />
              <Route path="/outros/fabind" component={FabricantesIndefinidos} />
              <Redirect path="*" to="/inicio" />
            </Switch>
            {/* <Route path="/anlrepo" component={AnaliseRepo} /> */}
            {/* <Route path="*" component={Indicadores} /> */}
          </>
          }

          {props.dados.tipo === 'fabricante' && <>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/sair" component={Logout} />
              <Route exact path="/inicio" component={Indicadores} />
              <Route path="/ranking" component={Painel} />
              <Route path="/anlrepo" component={AnaliseRepo} />

              <Route path="/powerbi" component={PowerBi} />
              {/* <Route path="/powerbi/:token" component={PowerBi} /> */}

              {/* <Route path="*" component={Indicadores} /> */}
              <Redirect path="*" to="/inicio" />
            </Switch>
          </>
          }

          {/* </Switch> */}
        </Router>
      )}
    </ErrorBoundary>
  );
}
const mapStateToProps = state => {
  return { auth: state.auth, dados: state.dados };
};

export default connect(mapStateToProps, { logIn, logOut, fetch, setDados })(Main);
